import { myInvitationInvalidation } from './invalidation-my-invitation';
import { ANNOUNCEMENT_INBOX_CACHE_KEYS, ANNOUNCEMENT_INBOX_SERVER_RENDERED, announcementInvalidation, } from './invalidation-announcements';
import { orgAccountInvalidation } from './invalidation-org-account';
import { PANEL_COMMERCE_CACHE_KEYS, PANEL_COMMERCE_SERVER_RENDERED, } from './invalidation-panel-commerce';
/**
 * Ayrı modüllerde tanımlanan önbellek ANAHTARLARI da tek girişten yayılır (ana
 * dosya tavana dayalı): panel ticareti ve duyuru alıcısı (T4a). Anahtar uzayı
 * yine TEKTİR (`CACHE_KEYS`), sunucu çizimi sınıflandırması da birlikte gelir.
 */
export const FAMILY_CACHE_KEYS = {
    ...PANEL_COMMERCE_CACHE_KEYS,
    ...ANNOUNCEMENT_INBOX_CACHE_KEYS,
};
export const FAMILY_SERVER_RENDERED = {
    ...PANEL_COMMERCE_SERVER_RENDERED,
    ...ANNOUNCEMENT_INBOX_SERVER_RENDERED,
};
/**
 * `invalidation.ts`e YAYILAN aileler tek girişten gelir (B-15): ana dosya
 * tavana dayalı, her yeni aile oraya bir içe aktarma + bir yayma satırı
 * eklemesin. Anahtarlar dışarıdan verilir (döngüsel bağımlılık yok).
 */
export function familyInvalidation(keys) {
    return {
        ...orgAccountInvalidation(keys),
        ...myInvitationInvalidation(keys),
        ...announcementInvalidation(keys),
        // "Okudum" (rıza Tur B): zorunlu metinlerin yeni sürüm satırları defteri bayatlatır.
        'account/consentAcknowledge': [keys.consentLedger],
        // Mobil eşi (rıza Tur C): "Okudum" ve onun tür başına adımı; saga yazımdan sonra defteri okur.
        'consents/acknowledge': [keys.consentLedger],
        'consents/acknowledgeStep': [keys.consentLedger],
    };
}
//# sourceMappingURL=invalidation-families.js.map